<h5 class="header" id="line-items">
  {{'ISSUE-TEXT.LINE-ITEMS' | translate}}
</h5>
<div class="box-content">
  <div [formGroup]="lineItemForm" style="margin-bottom: -1rem;">
    <div class="table-responsive">
      <table class="table table-borderless" aria-describedby="line-items">
        <thead class="text-center">
          <tr>
            <th scope="col" style="width: 12%;">{{'ISSUE-TEXT.PRODUCT-ID'|translate}}</th>
            <th scope="col">{{'ISSUE-TEXT.DESCRIPTION'|translate}}</th>
            <th scope="col" style="width: 100px;">{{'ISSUE-TEXT.QTY'|translate}}</th>
            <th scope="col" style="width: 100px;">{{'ISSUE-TEXT.UNIT'|translate}}</th>
            <th scope="col" style="width: 12%;">{{'ISSUE-TEXT.UNIT-PRICE'|translate}}</th>
            <th scope="col" style="width: 12%;">{{'ISSUE-TEXT.VAT-TYPE'|translate}}</th>
            <th scope="col" style="width: 12%;">{{'ISSUE-TEXT.DISCOUNT'|translate}}</th>
            <th scope="col" style="width: 12%;">{{'ISSUE-TEXT.TOTAL'|translate}}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container formArrayName="items">
            <ng-container *ngFor="let item of items.controls; let i=index">
              <ng-container [formGroupName]="i">
                <tr>
                  <td>
                    <ng-select class="custom"
                        [items]="products"
                        [addTag]="true"
                        labelForId="product-id"
                        bindLabel="product_id"
                        bindValue="product_id"
                        placeholder="{{'FILTER.PLACEHOLDER' | translate}}"
                        [addTagText]="'NORMAL.ADD'|translate"
                        [clearable]="false"
                        formControlName="productID" (change)="setProduct($event, item)">
                    </ng-select>
                  </td>
                  <td>
                    <ng-select class="custom"
                          [items]="products"
                          [addTag]="true"
                          labelForId="product-name"
                          bindLabel="name_en"
                          bindValue="name_en"
                          placeholder="{{'FILTER.PLACEHOLDER' | translate}}"
                          [addTagText]="'NORMAL.ADD'|translate"
                          [clearable]="false"
                          formControlName="description" (change)="setProduct($event, item)">
                    </ng-select>
                    <div *ngIf="getDescription(i).errors?.required && isSubmitted">
                      <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                    </div>
                  </td>
                  <td>
                    <input class="form-control text-right" type="text" formControlName="quantity" mask="separator.0"
                      thousandSeparator=",">
                    <div *ngIf="getQuantity(i).errors?.required && isSubmitted">
                      <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                    </div>
                  </td>
                  <td>
                    <input class="form-control text-right" type="text" formControlName="unit">
                  </td>
                  <td>
                    <input class="form-control text-right" type="text" formControlName="unitPrice" mask="separator.2"
                      thousandSeparator=",">
                    <div *ngIf="getUnitPrice(i).errors?.required && isSubmitted">
                      <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                    </div>
                  </td>
                  <td>
                    <p-dropdown *ngIf="!isReceipt" class="dv-dropdown" [options]="vats" formControlName="lineVAT">
                      </p-dropdown>
                  </td>
                  <td>
                    <input class="form-control text-right" type="text" formControlName="discount" mask="separator.2"
                      thousandSeparator=",">
                  </td>
                  <td class="text-right">
                    <div class="row align-items-center no-gutters">
                      <div class="col">
                        <p class="form-control m-0">{{ getTotal(i).toNumber() | currency:' ' }}</p>
                      </div>
                      <div class="col-auto p-l-5" *ngIf="i !==0 ">
                        <button class="ui-button bg-danger border-danger ui-button-icon-only"
                          (click)="removeItem(i)">
                          <em class="fa fa-trash-alt"></em>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td class="p-y-0">
                    <textarea class="form-control"
                        id="note"
                        formControlName="note"
                        placeholder="{{'ISSUE-TEXT.NOTE'|translate}}"
                        rows="1"></textarea>
                  </td>
                  <td colspan="6"></td>
                </tr>
              </ng-container>
            </ng-container>
          </ng-container>
          <tr>
            <td colspan="8">
              <button class="ui-button ui-button-icon-only" (click)="addItem()">
                <em class="fa fa-plus"></em>
              </button>
              <span>
                {{'ISSUE-TEXT.ADD-ITEM'|translate}}
              </span>
            </td>
          </tr>
          <tr class="border-top">
            <td colspan="8">
              <div class="row no-gutters">
                <div class="col-md-6">
                  <div class="row mb-3">
                    <div class="col-md-4">
                      {{'ISSUE-TEXT.AMOUNT' | translate}}
                    </div>
                    <div class="col-md-8">
                      {{ amountText }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-4">
                      {{'ISSUE-TEXT.REASON-OF-DISCOUNT' | translate}}
                    </div>
                    <div class="col-md-8">
                      <textarea class="form-control" formControlName="discountReason" row="2"></textarea>
                    </div>
                  </div>
                  <div *ngIf="isCreditNote || isDebitNote" class="row m-t-5">
                    <div class="col-md-4">
                      {{'ISSUE-TEXT.ORIGINAL-AMOUNT' | translate}}
                    </div>
                    <div class="col-md-8">
                      <input class="form-control text-right"
                          type="text"
                          formControlName="originalAmount"
                          mask="separator.2"
                          thousandSeparator=",">
                      <ng-container *ngIf="originalAmount.errors?.required && isSubmitted">
                        <span class="text-danger">{{ 'ERROR.REQUIRED' | translate }}</span>
                      </ng-container>
                    </div>
                  </div>
                  <div *ngIf="isCreditNote || isDebitNote" class="row">
                    <div class="col-md-4">
                      {{'ISSUE-TEXT.ORIGINAL-VAT' | translate}}
                    </div>
                    <div class="col-md-8">
                      <input class="form-control text-right"
                          type="text"
                          formControlName="originalVAT"
                          mask="separator.2"
                          thousandSeparator=",">
                      <ng-container *ngIf="originalVAT.errors?.required && isSubmitted">
                        <span class="text-danger">{{ 'ERROR.REQUIRED' | translate }}</span>
                      </ng-container>
                    </div>
                  </div>
                  <div *ngIf="isCreditNote || isDebitNote" class="row m-t-5">
                    <div class="col-md-4">
                      {{'ISSUE-TEXT.NEW-AMOUNT' | translate}}
                    </div>
                    <div class="col-md-8">
                      <p class="form-control m-0 text-right">{{ correctAmount.toNumber() | currency:' ' }}</p>
                      <ng-container *ngIf="correctAmount < 0 && isSubmitted">
                        <span class="text-danger">{{ 'ERROR.INVALID' | translate }}</span>
                      </ng-container>
                    </div>
                  </div>
                  <div *ngIf="isReceiptTaxInvoice && showAbbNetTotal" class="row m-t-5">
                    <div class="col-md-4">
                      {{'ISSUE-TEXT.REF-ABB-PAYMENT' | translate}}
                    </div>
                    <div class="col-md-8">
                      <p class="form-control">{{ abbData.payment_type }}</p>
                    </div>
                  </div>
                  <ng-container formArrayName="paymentMethods">
                    <ng-container *ngFor="let payment of paymentMethods.controls; let i=index;">
                      <ng-container [formGroupName]="i">
                        <div class="payment-box">
                          <div class="row m-t-5">
                            <div class="col-md-4">
                              {{i + 1}}. {{'ISSUE-TEXT.PAYMENT.TEXT' | translate}}
                            </div>
                            <div [ngClass]="{
                              'col-md-8': i === 0,
                              'col-md-7': i !== 0
                            }">
                              <ng-select class="custom"
                                  id="payment-type"
                                  [items]="paymentChoices"
                                  bindLabel="label"
                                  bindValue="value"
                                  formControlName="paymentType"
                                  [clearable]="true"
                                  appendTo="body"
                                  (change)="resetPaymentDetail(i)"
                                  placeholder="{{'FILTER.PLACEHOLDER' | translate}}">
                              </ng-select>
                            </div>
                            <div *ngIf="i !== 0" class="col-md-1 p-0 p-t-5">
                              <button (click)="removePaymentMethod(i)" class="ui-button bg-danger border-danger ui-button-icon-only">
                                <i class="fa fa-trash-alt"></i>
                              </button>
                            </div>
                          </div>
                          <ng-container *ngIf="showDropdownOption(i)">
                            <div *ngIf="getPaymentMethodControl(i, 'paymentType').value === 'credit_card'" class="row m-t-5">
                              <div class="col-md-4">
                                {{'ISSUE-TEXT.PAYMENT.TYPE' | translate}}
                              </div>
                              <div class="col-md-8">
                                <ng-select class="custom"
                                    id="credit-card"
                                    [items]="creditCardChoices"
                                    bindLabel="label"
                                    bindValue="value"
                                    formControlName="optionType"
                                    appendTo="body"
                                    placeholder="{{'FILTER.PLACEHOLDER' | translate}}">
                                </ng-select>
                              </div>
                              <div class="col-md-12 text-right">
                                <div *ngIf="getPaymentOptionType(i).errors?.required && isSubmitted">
                                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="getPaymentMethodControl(i, 'paymentType').value === 'bank_transfer'" class="row m-t-5">
                              <div class="col-md-4">
                                {{'ISSUE-TEXT.PAYMENT.TYPE' | translate}}
                              </div>
                              <div class="col-md-8">
                                <ng-select class="custom"
                                    id="bank-transfer"
                                    [items]="bankChoices"
                                    bindLabel="label"
                                    bindValue="value"
                                    formControlName="optionType"
                                    appendTo="body"
                                    placeholder="{{'FILTER.PLACEHOLDER' | translate}}">
                                </ng-select>
                              </div>
                              <div class="col-md-12 text-right">
                                <div *ngIf="getPaymentOptionType(i).errors?.required && isSubmitted">
                                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="getPaymentMethodControl(i, 'paymentType').value === 'payment_gateway'" class="row m-t-5">
                              <div class="col-md-4">
                                {{'ISSUE-TEXT.PAYMENT.TYPE' | translate}}
                              </div>
                              <div class="col-md-8">
                                <ng-select class="custom"
                                    id="payment-gateway"
                                    [items]="paymentGatewayChoices"
                                    bindLabel="label"
                                    bindValue="value"
                                    formControlName="optionType"
                                    appendTo="body"
                                    placeholder="{{'FILTER.PLACEHOLDER' | translate}}">
                                </ng-select>
                              </div>
                              <div class="col-md-12 text-right">
                                <div *ngIf="getPaymentOptionType(i).errors?.required && isSubmitted">
                                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                                </div>
                              </div>
                            </div>
                            <div *ngIf="getPaymentMethodControl(i, 'paymentType').value === 'online_shop'" class="row m-t-5">
                              <div class="col-md-4">
                                {{'ISSUE-TEXT.PAYMENT.TYPE' | translate}}
                              </div>
                              <div class="col-md-8">
                                <ng-select class="custom"
                                    id="online-shop"
                                    [items]="onlineShopChoices"
                                    bindLabel="label"
                                    bindValue="value"
                                    formControlName="optionType"
                                    appendTo="body"
                                    placeholder="{{'FILTER.PLACEHOLDER' | translate}}">
                                </ng-select>
                              </div>
                              <div class="col-md-12 text-right">
                                <div *ngIf="getPaymentOptionType(i).errors?.required && isSubmitted">
                                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                          <div *ngIf="getPaymentMethodControl(i, 'paymentType').value === 'bank_transfer'" class="row m-t-5">
                            <div class="col-md-4">
                              {{'ISSUE-TEXT.PAYMENT.TRANSFER-DATE' | translate}}
                            </div>
                            <div class="col-md-8">
                              <p-calendar formControlName="transferDate"
                                  id="transfer-date"
                                  readonlyInput="true"
                                  [showIcon]="true"
                                  dateFormat="dd/mm/yy"
                                  [locale]="calendarLocale"
                                  [yearNavigator]="true"
                                  yearRange="2000:2030"
                                  id="cheque-date">
                              </p-calendar>
                            </div>
                            <div class="col-md-12 text-right">
                                <div *ngIf="getPaymentTransferDate(i).errors?.required && isSubmitted">
                                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                                </div>
                              </div>
                          </div>
                          <div *ngIf="showNoteBox(i)" class="row m-t-5">
                            <div class="col-md-4">
                              {{'ISSUE-TEXT.PAYMENT.NOTE' | translate}}
                            </div>
                            <div class="col-md-8">
                              <textarea class="form-control" formControlName="note" id="note" row="2"></textarea>
                            </div>
                          </div>
                          <ng-container *ngIf="getPaymentMethodControl(i, 'paymentType').value === 'cheque'">
                            <div class="row m-t-5">
                              <div class="col-md-4">
                                {{'ISSUE-TEXT.PAYMENT.CHEQUE-NO' | translate}}
                              </div>
                              <div class="col-md-8">
                                <input class="form-control" type="text" id="cheque-no" formControlName="chequeNo"/>
                              </div>
                            <div class="col-md-12 text-right">
                              <div *ngIf="getPaymentChequeNO(i).errors?.required && isSubmitted">
                                <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                              </div>
                            </div>
                            </div>
                            <div class="row m-t-5">
                              <div class="col-md-4">
                                {{'ISSUE-TEXT.PAYMENT.BANK' | translate}}
                              </div>
                              <div class="col-md-8">
                                <input class="form-control" type="text" id="cheque-bank" formControlName="chequeBank"/>
                              </div>
                              <div class="col-md-12 text-right">
                                <div *ngIf="getPaymentBank(i).errors?.required && isSubmitted">
                                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                                </div>
                              </div>
                            </div>
                            <div class="row m-t-5">
                              <div class="col-md-4">
                                {{'ISSUE-TEXT.PAYMENT.CHEQUE-DATE' | translate}}
                              </div>
                              <div class="col-md-8">
                                <p-calendar class="dv-dropdown"
                                    id="cheque-date"
                                    formControlName="chequeDate"
                                    readonlyInput="true"
                                    [showIcon]="true"
                                    dateFormat="dd/mm/yy"
                                    [locale]="calendarLocale"
                                    [yearNavigator]="true"
                                    yearRange="2000:2030"
                                    id="cheque-date">
                                </p-calendar>
                              </div>
                              <div class="col-md-12 text-right">
                                <div *ngIf="getPaymentChequeDate(i).errors?.required && isSubmitted">
                                  <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                          <div class="row m-t-5">
                            <div class="col-md-12 text-right">
                              <div *ngIf="getPaymentType(i).errors?.required && isSubmitted">
                                <span class="text-danger text-left">{{ 'ERROR.REQUIRED' | translate }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <div class="row">
                    <div class="col-md-12">
                      <button class="ui-button ui-button-icon-only" (click)="addPaymentMethod()">
                        <em class="fa fa-plus"></em>
                      </button>
                      <span>
                        {{'ISSUE-TEXT.PAYMENT.ADD-PAYMENT' | translate}}
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row no-gutters text-right">
                    <div class="col-md-9">
                      {{'ISSUE-TEXT.SUB-TOTAL' | translate}}
                    </div>
                    <div class="col-md-3">
                      {{ subTotal.toNumber() | currency:' ' }}
                    </div>
                  </div>
                  <div class="row no-gutters text-right m-t-16">
                    <div class="col-md-9">
                      {{'ISSUE-TEXT.LINE-ITEM-DISCOUNT-TOTAL' | translate}}
                    </div>
                    <div class="col-md-3">
                      {{ discountTotal.toNumber() | currency:' ' }}
                    </div>
                  </div>
                  <ng-container formArrayName="endBillDiscountList">
                    <ng-container *ngFor="let endBillDiscount of endBillDiscountList.controls; let i=index">
                      <ng-container [formGroupName]="i">
                        <div class="row no-gutters" [ngClass]="{
                          'm-t-10': i === 0,
                          'm-t-5': i !== 0
                        }">
                          <div class="col-md-9 text-right">
                            <div class="row no-gutters justify-content-end">
                              <div class="col-auto align-self-center">
                                {{'ISSUE-TEXT.END-BILL-DISCOUNT' | translate}}
                              </div>
                              <div class="col-auto p-x-5">
                                <p-dropdown class="dv-dropdown"
                                    [options]="vats"
                                    formControlName="typeDiscount"
                                    appendTo="body">
                                </p-dropdown>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-3">
                            <div class="row no-gutters justify-content-end align-self-center">
                              <div class="col-md-10 align-self-center pr-1">
                                <input class="form-control text-right" type="text" formControlName="endBillDiscount" mask="separator.2"
                                thousandSeparator=",">
                              </div>
                              <div class="col-md-2 align-self-center">
                                <button *ngIf="i==0" [ngClass]="isDisableAddDiscount ? 'disable':'ui-button'" (click)="!isDisableAddDiscount && addEndBillDiscount()">
                                  <i class="fa fa-plus mx-1"></i>
                                </button>
                                <button *ngIf="i!==0" class="ui-button bg-danger border-danger" (click)="removeEndBillDiscount(i)">
                                  <i class="fa fa-trash-alt mx-1"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="nonVATAmount.isNegative() || vatAmount.isNegative() || vat0Amount.isNegative()" class="text-right text-danger">
                    {{'ISSUE-TEXT.AMOUNT-ERROR' | translate}}
                  </ng-container>
                  <div class="row no-gutters text-right m-t-16">
                    <div class="col-md-9">
                      {{'ISSUE-TEXT.BALANCE' | translate}}
                    </div>
                    <div class="col-md-3">
                      {{ balance.toNumber() | currency:' ' }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="border-top">
            <td colspan="7">
              <div class="row no-gutters justify-content-end">
                <div class="col-auto align-self-center">
                  {{'ISSUE-TEXT.VAT' | translate}}
                </div>
              </div>
            </td>
            <td class="text-right">
              <input class="form-control text-right" type="text" formControlName="vat" thousandSeparator="," mask="separator.2">
            </td>
          </tr>
          <tr>
            <td colspan="7" class="text-right">
              {{'ISSUE-TEXT.NET-TOTAL' | translate}}
              <span *ngIf="isSubmitted && !matchedAbbValue" class="d-block text-danger">
                {{'ERROR.INVALID-AMOUNT' | translate}}
              </span>
            </td>
            <td class="text-right">
              {{ netTotal.toNumber() | currency:' ' }}
            </td>
          </tr>
          <tr *ngIf="showAbbNetTotal">
            <td colspan="7" class="text-right">
              {{'ISSUE-TEXT.ABB-TOTAL-AMOUNT' | translate}}
            </td>
            <td class="text-right">
              {{ abbData.total_payment | currency:' ' }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/document/document-issue/components/line-item-form/line-item-form.component.html